import script from "./terms-and-conditions.vue?vue&type=script&setup=true&lang=js"
export * from "./terms-and-conditions.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__